import { RefreshCcw } from "lucide-react";
import { useFormContext } from "react-hook-form";

import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

import { CreateBreakoutSessionsFormData } from "../types/create-breakout-sessions.schema";

export function ResetBreakoutSessionsElement() {
  const form = useFormContext<CreateBreakoutSessionsFormData>();

  const handleReset = () => {
    form.reset({
      breakoutSessions: [
        {
          name: `Breakout Room 1`,
          participants: [],
        },
      ],
    });
  };

  return (
    <div className="flex flex-col">
      <Label className="mb-1.5">Reset</Label>
      <Button
        variant="ghost"
        size="icon"
        className="size-10"
        onClick={handleReset}
        type="button"
      >
        <RefreshCcw />
      </Button>
    </div>
  );
}
